module.exports = __webpack_public_path__ + "static/media/KMH_5332.cae78938.jpg";